export const API = process.env.REACT_APP_API_URL;
export const G_KEY = process.env.REACT_APP_GOOGLE_KEY;
export const FRESHCHAT_TOKEN = process.env.REACT_APP_FRESH_CHAT_TOKEN;
export const GA_TRACKING_ID = process.env.REACT_APP_GOOGLE_TRACKING_ID;
export const ENV = process.env.REACT_APP_ENV;